<template>
  <div class="ax-fold-box">
      <div class="fold_content" ref="content" style="height: 0px;">
        <slot></slot>
      </div>
      <div class="fold_top" @click="collapse">
        <van-icon :class="active?'icon_active':''" name="arrow-down"></van-icon>
        <!-- <span v-html="active?'收起':'展开'"></span> -->
      </div>
  </div>
</template>

<script>
import { setTimeout, clearTimeout } from 'timers';

  export default {
    name: "ax-fold",
    data() {
      return {
        active: false,
        timer: null
      }
    },
    methods:{
      collapse(){
        this.active = !this.active;
        let height = this.$refs.content.getBoundingClientRect().height;
        if (!!height) {
          this.$refs.content.style.height = height + 'px'
          var f = document.body.offsetHeight
          this.$refs.content.style.height = '0px'
        } else {
          this.$refs.content.style.height = 'auto'
          height = this.$refs.content.getBoundingClientRect().height
          this.$refs.content.style.height = '0'
          var f = document.body.offsetHeight
          this.$refs.content.style.height = height + 'px'
          var _this = this;
          clearTimeout(this.timer);
          this.timer = setTimeout(()=>{
            _this.$refs.content.style = null
          },300)
          
        }
      }
    },
    beforeDestroy(){
      clearTimeout(this.timer);
    }
  }
</script>

<style lang="scss" scoped>
  .ax-fold-box{
    overflow: hidden;
    .fold_top{
      cursor: pointer;
      line-height: 44px;
      height: 44px;
      color: $title-color;
      display: flex;
      justify-content: center;
      overflow: hidden;
      position: relative;
      z-index: 1;
      font-size: 12px;
      .van-icon{
        padding: 0 9px;
        line-height: 44px;
        font-size: 16px;
        -webkit-transition: -webkit-transform .3s cubic-bezier(.86,0,.07,1);
        transition: -webkit-transform .3s cubic-bezier(.86,0,.07,1);
        transition: transform .3s cubic-bezier(.86,0,.07,1);
        transition: transform .3s cubic-bezier(.86,0,.07,1),-webkit-transform .3s cubic-bezier(.86,0,.07,1);
      }
      .icon_active{
        transform: rotate(180deg);
      }
    }
    .fold_content{
      transition: height .3s;
      -webkit-transition: height .3s;
      overflow: hidden;
    }
  }
</style>
<style lang="scss" scoped>
  .fold_content{
    .form_a {
      font-size: 16px;
      color: $link-a;
    }
  }
</style>

